import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";
import { AdministratorPermissions, TeacherPermissions } from "./routes";
export default store => ({
  path: "staff-permissions",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "staff-permissions" */ "./components"),
        import(
          /* webpackChunkName: "staff-permissions" */ "./modules/StaffPermissionsModule"
        ),
        import(
          /* webpackChunkName: "staff-permissions" */ "./modules/StaffPermissionsModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const { MODULE_KEY } = importedModule2;
        injectReducer(store, {
          key: MODULE_KEY,
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == "staff-permissions") {
      const route = getNextMenuRoute("STAFF_PERMISSIONS");
      if (route) {
        if (route === "administrators") {
          replace(getRelativePath(route));
        } else {
          replace(getRelativePath(`teachers/${route}`));
        }
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [AdministratorPermissions(store), TeacherPermissions(store)],
});
